import {importLazyFrame} from "./kp-util";

let iframes = document.querySelectorAll('iframe')

iframes.forEach(function(el) {
  el.classList.add('lazyframe')
})

const elements = document.querySelectorAll(".lazyframe");

if (elements.length > 0) {
  importLazyFrame().then((lazyframe) => {
    lazyframe(".lazyframe");

    let iframes = document.querySelectorAll(".lazyframe");
    lazyframe(iframes);

    // Passing a jQuery object
    let elements = jQuery(".lazyframe");
    lazyframe(elements);
  })
}